'use strict';

function formatChainMetricValue(metricName, value) {
  switch (metricName) {
    case 'Chain/BpJsonStatus':
      return formatBpJsonStatus(value);
    default:
      return { short: value, long: value };
  }
}

function formatBpJsonStatus(value) {
  const statusMappings = {
    OK: {
      short: 'OK',
      long: 'Both chains.json and bp.json OK',
    },
    'chains.json_could_not_be_fetched': {
      short: 'Warning',
      long: 'Could not fetch chains.json',
    },
    'bp.json_not_found_in_chains.json': {
      short: 'Error',
      long: 'Chain not found in chains.json',
    },
    'bp.json_could_not_be_fetched': {
      short: 'Error',
      long: 'Could not fetch bp.json',
    },
    'bp.json_could_not_be_parsed': {
      short: 'Error',
      long: 'Unexpected bp.json format',
    },
    producer_account_name_could_not_be_found: {
      short: 'Error',
      long: 'Missing producer_account_name in bp.json',
    },
  };
  return (
    statusMappings[value] || {
      short: 'Unknown',
      long: `Unknown status: ${value}`,
    }
  );
}

export { formatChainMetricValue };
